import { Card, Col } from "antd";
import { useMemo } from "react";
import { getPriceForCurrency } from "../helper";

const PriceCard = ({
  setSelectedPlanId,
  selectedPlanId,
  plan,
  currencySymbol,
  currency,
  memberAmount,
}) => {
  const amount = useMemo(() => {
    const planPrice = getPriceForCurrency(plan.price, currency);
    return parseFloat(planPrice.amount) / 100;
  }, [currency, plan]);

  return (
    <Col
      xs={24}
      sm={24}
      md={12}
      lg={8}
      onClick={() => setSelectedPlanId(plan?.id)}
      className="cursor-pointer"
    >
      <Card
        className={`pricing-card ${selectedPlanId === plan.id ? "selected" : ""}`}
      >
        <div className="pricing-header">
          <div className="plan-name">{plan.name}</div>
          <div className="plan-description">{plan.descriptions}</div>
        </div>

        <div className="price-display">
          <div className="base-price">
            <span className="currency">{currencySymbol}</span>
            <span className="amount">{amount.toFixed(0)}</span>
            <span className="period">/month</span>
          </div>
          <div className="per-member-text">
            <span>
              <span className="member-price">
                {currencySymbol}
                {memberAmount.toFixed(2)}{" "}
              </span>
              per team member / month
            </span>
          </div>
        </div>
        <div className="pricing-features">
          {plan?.description?.split(",")?.map((feature, fIdx) => (
            <div key={fIdx} className="feature-item">
              {feature}
            </div>
          ))}
        </div>
      </Card>
    </Col>
  );
};

export default PriceCard;
